/*
 * @Author: wangbaihe
 * @Date: 2024-06-27 16:53:20
 * @LastEditors: wangbaihe
 * @LastEditTime: 2024-06-27 16:53:20
 * @FilePath: \common-mediax\src\apis\MediaCloudArticleEdit\Permission.js
 * @Description: MediaCloudConfigColumn
 */
import { createAPI } from '@common'

export default {
  // 发布库栏目树
  // getColumns: config => createAPI('customEncryptApiName-1/0w20dpmvnot0pme', 'get', config),
  // 获取根栏目
  getColumnRoot: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20dpmvnot0sppu', 'get', config, {
        hubForward: true,
        hub: 'e5/hub'
      })
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0sppu', 'get', config, null)
    }
  }, // type=0&ch=1&siteID=1
  getColumnInfo: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20dpmvnot0hfuDpmvno', 'get', config, {
        hubForward: true,
        hub: 'e5/hub'
      })
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0hfuDpmvno', 'get', config, null)
    }
  },
  // 获取网站发布根栏目
  getColumnwebsRoot: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20dpmvnot0sppu', 'get', config, {
        hubForward: true,
        hub: 'e5/hub'
      })
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0sppu', 'get', config, null)
    }
  },
  // 获取子栏目
  getColumns: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20dpmvnot', 'get', config, {
        hubForward: true,
        hub: 'e5/hub'
      })
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot', 'get', config, null)
    }
  }, // parent=
  // 获取网站发布子栏目
  getColumnwebs: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20dpmvnot', 'get', config, {
        hubForward: true,
        hub: 'e5/hub'
      })
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct', 'get', config, null)
    }
  }, // parent=
  deleteColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0efmfuf', 'delete', config),
  //订阅号导出
  postColumnExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0fyqpsu', 'post', config),
  //复制
  postColumnCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0dpqz', 'post', config),
  // 发布库栏目树(子栏目)
  // 栏目设置-读已有的聚合情况
  getAggregation: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0bhhsfhbujpo', 'get', config),
  getArticleColumnAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0hfuBsujdmfDpmvnoBmm', 'get', config),
  // 栏目设置-保存聚合情况
  submitAggregation: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0bhhsfhbujpo', 'post', config),
  // 扩展属性列表
  getExtfieldsList: (config) => createAPI('customEncryptApiName-1/0w20fyugjfmet0mjtu', 'get', config),
  getColumnsSearch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tfbsdi', 'get', config, {
      neverLoading: true
    }),
  getColumnwebsSearch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0tfbsdi', 'get', config, {
      neverLoading: true
    }),

  getFolderUsedByCols: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0gpmefsVtfeCzDpmt', 'get', config, {
      neverLoading: true
    }),
  // 栏目树拖动排序
  getColumnsDrag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0npwf', 'post', config),
  // 发布栏目树拖动排序
  postNewColumnsDrag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0esbh', 'post', config),
  // 栏目恢复
  getColumnsRestore: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0sftupsf', 'get', config),
  // 查询流程记录
  getLogs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0f60bdujpot0mpht', 'get', config),
  // 栏目恢复
  restore: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0sftupsf', 'get', config),
  // 稿件类型获取所有分类
  getCatTypes: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0dbuuzqft', 'get', config),
  // 稿件类型获取分类根节点
  getCatRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0spput', 'get', config, {
      neverLoading: true
    }),
  // 稿件类型获取分类子节点
  getCatSub: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0dbut', 'get', config, {
      neverLoading: true
    }),

  // 稿件类型新增
  putCatSub: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0dbu', 'put', config),
  // 稿件类型新增
  postCheckCat: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0difdlDbu', 'POST', config),
  // 稿件类型新增
  deleteCatSub: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0dbu', 'Delete', config),
  // 网站栏目设置-读已有的聚合情况
  getAggregationWeb: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0bhhsfhbujpo', 'get', config),
  // 网站栏目设置-保存聚合情况
  submitAggregationWeb: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0bhhsfhbujpo', 'post', config),
  getE5ListsDefinition: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0f60mjtut0efgjojujpo', 'get', config, vconfig),
  postE5ListsDefinition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0f60mjtut0efgjojujpo', 'post', config),

  // 根据参考分类，生成分类描述
  postAiExtractDescription: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0dbufhpsz0fyusbdu0eftdsjqujpo', 'post', config),

  // 查看运营者信息（订阅栏目）
  getOperationInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0pqfsbujpoJogp', 'get', config),
  // 保存运营者信息
  saveOperationInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tbwfPqfsbujpoJogp', 'post', config)
}
